import pointerSvg from './assets/pointer.svg';

export const config = {
    baseHtmlClass: `popover_window__pointer`,
    selector: 'popover_window__pointer',

    pointerSvg: pointerSvg,
}

export class popoverWindowPointer {

    static createElement() {
        let element = document.createElement('div');
        element.setAttribute("class", config.baseHtmlClass);
        element.innerHTML = config.pointerSvg;
        return element;
    }
}

